import styled from "styled-components";
import {StyleDiv} from "components/Common/StyleDiv";

export const StyleCard = styled(StyleDiv)`
  display: ${(props) => props.display};
  flex-direction: ${(props) => props.flexDirection};
  align-items: ${(props) => props.alignItems};
  justify-content: ${(props) => props.justifyContent};
  position: ${(props) => props.position};
  top: ${(props) => props.top};
  right: ${(props) => props.right};
  bottom: ${(props) => props.bottom};
  left: ${(props) => props.left};
  margin: ${(props) => props.margin};
  margin-left: ${(props) => props.marginLeft};
  margin-right: ${(props) => props.marginRight};
  padding: ${(props) => props.padding || "1rem"};
  overflow: ${(props) => props.overflow};
  overflow-y: ${(props) => props.overflowY};
  background-color: ${(props) => props.backgroundColor || "var(--card)"};
  color: ${(props) => props.color || "var(--fg)"};
  border-radius: ${(props) => props.borderRadius || "var(--radius-lg)"};
  box-shadow: ${(props) => props.boxShadow || "var(--shadow-soft)"};
  border: ${(props) => props.border || "1px solid var(--line)"};
  transition: ${(props) => props.transition};
  margin-bottom: ${(props) => props.marginBottom};
  height: ${(props) => props.height};
  max-height: ${(props) => props.maxHeight};
`;
